import React from 'react';
import { SearchClear } from '../../_Components';

const SearchBar = ({ onSearch, value = '', placeholder = 'Поиск сотрудника' }) => (
    <div className="pc-sched-srch">
        <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.6">
            <circle cx="7" cy="7" r="4.5" />
            <path d="M10.5 10.5L14 14" />
        </svg>
        <input
            className="pc-sched-inp"
            type="text"
            placeholder={placeholder}
            value={value}
            onChange={(event) => onSearch(event.target.value)}
            autoComplete="off"
        />
        <SearchClear visible={Boolean(value)} onClear={() => onSearch('')} />
    </div>
);

export default SearchBar;
